import React from "react"

const gayatri_potbhare = () => {
    return (
        <div>
<h1>Gayatri Potbhare</h1>

<h4><em>Computer Engineering, Batch of 27'<br/><hr/></em></h4>

<p><strong>What was the criteria for shortlisting candidates in the initial stages of the recruitment process</strong>?<br />
There were two main criteria for shortlisting candidates in the initial stage:</p>

<ol>
<li><p>The candidate should have <strong>no active backlogs</strong>.</p></li>
<li><p>The candidate should have a <strong>minimum CGPA of 7.5</strong>.</p></li>
</ol>

<p><strong>What was the timeline of the entire Interview Process</strong>?<br />
The entire interview process took place over a few days:</p>

<ul>
<li><p>On <strong>10th September</strong>, the <strong>shortlisted candidates from the aptitude round</strong> were announced.</p></li>
<li><p>On <strong>16th September</strong>, the <strong>interview round</strong> was conducted.</p></li>
<li><p>On <strong>17th September</strong>, the <strong>final selection results</strong> were declared.</p></li>
</ul>

<p><strong>What was the structure of the Aptitude Round?</strong><br />
The aptitude round included:</p>

<ul>
<li><strong>Mathematical and logical reasoning questions</strong>, followed by <strong>Two coding problems</strong> - both to be solved in the <strong>C language only</strong> (no other language was allowed).</li>
</ul>

<p>The coding questions were:</p>

<ol>
<li><p><strong>FizzBuzz</strong> – a simple logic-based question (commonly found on HackerRank).</p></li>
<li><p><strong>Reverse a Digit</strong> – a basic DSA problem testing understanding of loops and number manipulation.</p></li>
</ol>

<p><strong>How many students were shortlisted after the Aptitude Round?</strong><br />
A total of <strong>nine female candidates</strong> were shortlisted for the interview round.</p>

<p><strong>After being shortlisted, how long was the wait time before the interviews began? During this period, what specific areas did you focus on to prepare effectively?</strong><br />
There was a gap of a few days between the aptitude test and the interviews.<br />
During this period, I revised <strong>all the topics mentioned in my resume</strong> to ensure I could confidently discuss any of them.<br />
However, my main focus was on <strong>Operating Systems</strong>, since it was specifically mentioned in the <strong>job description</strong> for the role.<br />
<strong>How many interview rounds were there for the company, can you elaborate about each round in brief? Also mention, how many students were shortlisted after each Interview Round?</strong><br />
<strong>Technical Interview 1:</strong><br />
 This round was primarily focused on <strong>Operating Systems (OS)</strong> and <strong>C programming</strong> - as C was the only language allowed for coding.<br />
 The interviewer also discussed one of my projects in detail.</p>

<p>The <strong>coding part</strong> was conducted <strong>live on HackerRank</strong>, where specific <strong>constraints</strong> were given to check both <strong>coding ability and OS understanding</strong>.<br />
 The question was related to <strong>memory management</strong> – two pointers were given, and I had to <strong>copy a specific number of bytes from the source to the destination</strong>.<br />
 This question then led to a series of <strong>in-depth questions</strong> on <strong>memory management concepts</strong> in OS.</p>

<p>After this round, only <strong>two students</strong> were selected for the next stage.</p>

<p><strong>What Topics or Skills did the interviewers focus on during the interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or Behavioral questions)</strong><br />
The interviewers mainly focused on <strong>Operating Systems (OS)</strong> – it was a must-know topic.<br />
 Most of the questions were based on <strong>multithreading, processes, and threads</strong>, along with a few additional constraints and follow-up questions in each topic.</p>

<p>Thanks to <strong>Abhijit Sir’s detailed OS lectures</strong>, I was able to answer these questions confidently and in depth.<br />
 The interviewers asked deeper questions depending on how much you explained – the <strong>more you say, the more they explore</strong> to test whether you truly understand the concept.</p>

<p><strong>What are some good resources that you used in your Internship Prep?</strong><br />
<strong>Modern Operating Systems (Fourth Edition)</strong> by <em>Andrew S. Tanenbaum</em> and <em>Herbert Bos</em> – This book helped me gain a strong foundational understanding of <strong>Operating System concepts</strong> during the initial stages of my preparation.</p>

<p><strong>Operating System lectures by Physics Wallah</strong> – These videos were useful for revising key OS topics in a simple and structured way.</p>

<p><strong>Database System Concepts</strong> by <em>Abraham Silberschatz</em>, <em>Henry F. Korth</em>, and <em>S. Sudarshan</em> – This book was excellent for strengthening my understanding of <strong>Database Management Systems</strong>.</p>

<p><strong>Some tips to crack Coding Questions?</strong><br />
For aptitude-based coding, practice on <strong>Codeforces</strong>. For interview-focused DSA preparation, refer to <strong>Take U Forward (TUF).</strong></p>

<p><strong>How many questions were asked about Projects, Clubs, and Extracurricular activities in your resume</strong>?<br />
Only <strong>one question</strong> was asked about my project.<br />
I was asked to <strong>explain the project briefly</strong>, and then there were a few <strong>follow-up questions</strong> based on what I had described.<br />
There were <strong>no questions</strong> about clubs or extracurricular activities.</p>

<p><strong>Is there something specific that you would want to tell people who are preparing for the same company</strong>?<br />
Make sure to learn <strong>Operating Systems in depth</strong> and get comfortable with <strong>C programming</strong>.<br />
 If possible, also have some understanding of <strong>Object-Oriented Programming (OOP)</strong> concepts.</p>

<p><strong>Any Final Tips for Juniors?</strong><br />
Don’t try to learn <em>everything</em> at once or compare yourself with others.<br />
 Instead of being a “jack of all trades,” <strong>focus on mastering a few topics deeply</strong> – especially the ones you mention in your resume.</p>

<p>It’s okay if your friends know many things; what truly matters is how well <em>you</em> understand what <em>you</em> claim to know.<br />
 Depth of knowledge always beats surface-level familiarity.</p>

<p><strong>Contact Info</strong><br />
<strong>Email :</strong> <a href="mailto:potbharegm24.comp@coeptech.ac.in">potbharegm24.comp@coeptech.ac.in</a></p>


<hr />

        </div>
    )
}

export default gayatri_potbhare
